export const RON = new Intl.NumberFormat("ro-RO", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});

export function formatPrice(v) {
  if (v == null) return "—";
  return RON.format(v);
}

export function formatKm(v) {
  if (v == null) return "—";
  return new Intl.NumberFormat("ro-RO").format(v) + " km";
}

export const FUELS = ["Benzină", "Motorină", "Hibrid", "Electric", "GPL"];
export const TRANSMISSIONS = ["Manuală", "Automată"];
export const DRIVETRAINS = [
  { value: "Față", label: "Față (FWD)" },
  { value: "Spate", label: "Spate (RWD)" },
  { value: "4x4", label: "4x4 / AWD" },
];
export const BODY_TYPES = [
  "Berlină",
  "Break",
  "SUV",
  "Coupé",
  "Hatchback",
  "Cabriolet",
  "Monovolum",
];
export const STATUSES = [
  { value: "nou", label: "Disponibilă" },
  { value: "rezervata", label: "Rezervată" },
  { value: "vanduta", label: "Vândută" },
];
export const INQUIRY_STATUSES = [
  { value: "noua", label: "Nouă" },
  { value: "contactata", label: "Contactată" },
  { value: "finalizata", label: "Finalizată" },
  { value: "respinsa", label: "Respinsă" },
];
export const SORT_OPTIONS = [
  { value: "recent", label: "Cele mai noi" },
  { value: "vechi", label: "Cele mai vechi" },
  { value: "pret_asc", label: "Preț crescător" },
  { value: "pret_desc", label: "Preț descrescător" },
  { value: "an_desc", label: "An descrescător" },
  { value: "km_asc", label: "Kilometraj crescător" },
];
